import { useState, useEffect } from 'react';

const useEducation = () => {
	const [locationOptions, setLocations] = useState([]);

	//	--------------------------------
	// 	Fetch Education locations list.
	//	--------------------------------
	useEffect(() => {
		fetch(process.env.GATSBY_EDUCATION_LOCATIONS_API)
			.then(response => { return response.json(); })
			.then(locationsList => {
				const formattedLocations = locationsList.map(({optionname, optionvalue}) => (
					{ label: optionname, value: optionvalue }
				));
				setLocations(formattedLocations);
			})
			.catch(error => {
				window.console.error(error);
			});
	}, []);

	return {
		locationOptions,
	};
};

export default useEducation;
